export const SIGN_IN_REQUEST = "SIGN_IN_REQUEST";
export const LOAD_REGISTERED_USER = "LOAD_REGISTERED_USER";

export const signInRequest = (username, password, history) => ({
    type: SIGN_IN_REQUEST,
    payload: {
        username,
        password,
        history
    }
});

export const loadRegisteredUserRequest = ({ user_id, access_token, refresh_token }, history) => ({
    type: LOAD_REGISTERED_USER,
    payload: {
        user_id,
        access_token,
        refresh_token,
        history
    }
});
